<template>
  <rd-font-manager id="font_manager" asDialog></rd-font-manager>

  <rd-page-layout showTop showLeft showCenter leftWidth="auto">
    <div slot="top">
      <rd-topbar id="topbar" logo="./images/Logo/logo.png"></rd-topbar>
    </div>
    <div slot="left" style="height: 100%">
      <rd-sidebar id="sidebar"></rd-sidebar>
    </div>
    <div slot="center" style="height: 100%; width: 100%">
      <CanvasArea />
    </div>
    <div slot="right">Right Panel</div>
  </rd-page-layout>

  <IconManagerDialog />
  <FileManagerDialog />
  <ImagePreviewer />

  <div id="input_highlighter"></div>
  <rd-navigator style="display: none"></rd-navigator>

  <!-- Dev test overlay for FileManager -->
  <Teleport to="body">
    <div v-if="fmTest.visible" class="fm-test-overlay" @click.self="fmTest.visible = false">
      <div class="fm-test-window">
        <FileManager
          :files="fmTest.files"
          :storage="fmTest.storage"
          @open-file="e => console.log('[FM] open-file', e)"
          @new-folder="(n, p) => console.log('[FM] new-folder', n, p)"
          @delete="e => console.log('[FM] delete', e)"
          @upload="(f, p) => console.log('[FM] upload', f, p)"
          @rename="e => console.log('[FM] rename', e)"
          @move="e => console.log('[FM] move', e)"
          @copy-paste="e => console.log('[FM] copy-paste', e)"
          @refresh="e => console.log('[FM] refresh', e)"
        />
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { reactive, onMounted } from 'vue';
import CanvasArea from './components/CanvasArea.vue';
import IconManagerDialog from './components/IconManagerDialog.vue';
import FileManagerDialog from './components/FileManagerDialog.vue';
import ImagePreviewer from './components/ImagePreviewer.vue';
import { FileManager } from './components/FileManager/index.js';

const fmTest = reactive({ visible: false, files: [], storage: null });

onMounted(() => {
  window.openFileManager = (files, storage) => {
    fmTest.files = files ?? [];
    fmTest.storage = storage ?? null;
    fmTest.visible = true;
  };
  window.closeFileManager = () => { fmTest.visible = false; };
});
</script>

<style>
.fm-test-overlay {
  position: fixed; inset: 0; z-index: 99999;
  background: rgba(0,0,0,.65);
  display: flex; align-items: center; justify-content: center;
}
.fm-test-window {
  width: min(960px, 94vw); height: min(650px, 90vh);
  border-radius: 12px; overflow: hidden;
  box-shadow: 0 24px 80px rgba(0,0,0,.6);
}
</style>
